import React, { useState, useRef, useEffect } from 'react';
import { ReadDataStorage, IDCOMPANY ,TOKEN_KEY} from '../../../services/auth'

const NPS = () => {
  const iframeRef = useRef(null);
  const _token = ReadDataStorage(TOKEN_KEY)
  const [url, setUrl] = useState(process.env.REACT_APP_NEW_LAYOUT + '/nps/' +  ReadDataStorage(IDCOMPANY) + '/' + JSON.parse(_token).token); 

  useEffect(() => {
    // Você pode colocar aqui lógica para montar dinamicamente a URL se necessário
  }, []);

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1 }}>
        <iframe
          ref={iframeRef}
          src={url} // Altere aqui
          title="NPS Dashboard"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  );
};

export default NPS;
